var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require('@/assets/images/progressive-logo.svg'),"width":"199","height":"auto","alt":"Progressive Logo"},on:{"click":function($event){$event.preventDefault();return _vm.goHome()}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }